module.exports = __webpack_public_path__ + "img/orange_099.ef31fe30.png";